export interface StatusTagProps {
  percentage?: number;
  isNotTagged?: boolean;
}

export enum StatusTagEnum {
  ALL_COMPLETED = 'All completed',
  HIGH_COMPLETION = 'High completion',
  LOW_COMPLETION = 'Low completion',
  NOT_STARTED = 'Not started',
  NOT_TAGGED = 'Not tagged',
}
